import React from "react";
import { Link } from "react-router-dom";

const NotFreeModal = ({ modalId, title, content }) => {
  return (
    <>
      {/* Delete Performance Indicator Modal */}
      <div className="modal custom-modal fade" id={modalId} role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content  ">
            <div className="modal-header card-header ">
              <h2 className="modal-title text-primary pb-3">{title}</h2>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>{" "}
            <div className="modal-body mt-0 pt-0 border-top-primary">
              <div className="form-header">
                <p className="fs-5 p-4"> {content} </p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row m-auto  ">
                  {/* <div className="col-6">
                    <Link to="#" className="btn btn-primary continue-btn">
                      اغلاق
                    </Link>
                  </div> */}

                  {/* <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn  cancel-btn w-25 p-1 m-auto"
                  >
                    اغلاق
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default NotFreeModal;
